const SvgProgressRing = ({ percent, size = 120, strokeWidth = 8, color = 'var(--pico-primary)' }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (Math.min(percent, 100) / 100) * circumference;
  const center = size / 2;

  return (
    <svg width={size} height={size} className="home-svg-ring">
      <circle
        cx={center}
        cy={center}
        r={radius}
        fill="none"
        stroke="var(--pico-card-sectioning-background-color)"
        strokeWidth={strokeWidth}
      />
      <circle
        cx={center}
        cy={center}
        r={radius}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        transform={`rotate(-90 ${center} ${center})`}
        className="home-svg-ring-fill"
      />
      <text
        x={center}
        y={center}
        textAnchor="middle"
        dominantBaseline="central"
        className="home-svg-ring-text"
        fill="currentColor"
        fontSize={size * 0.22}
        fontWeight={700}
      >
        {Math.round(percent)}%
      </text>
    </svg>
  );
};

export default SvgProgressRing;
